import { Link } from "react-router-dom";
import { CalendarDays, Target, Globe } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const StickyCTA = () => {
  const { lang } = useLang();
  const t = (de, en) => (lang === "de" ? de : en);

  return (
    <div
      data-testid="sticky-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#050505]/95 backdrop-blur-xl border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-3 gap-2 px-2 py-2 sm:px-4 sm:py-3">
        <Link
          to="/kurse"
          data-testid="sticky-cta-kurse"
          className="flex items-center justify-center gap-1.5 sm:gap-2 border border-white/20 text-white font-heading uppercase tracking-wide text-[11px] sm:text-sm py-3 px-1 hover:border-[#ff0033] hover:text-[#ff0033] transition-colors"
        >
          <CalendarDays size={15} className="shrink-0" />
          <span className="truncate">{t("Kurse", "Courses")}</span>
        </Link>
        <Link
          to="/einzeltraining"
          data-testid="sticky-cta-einzeltraining"
          className="flex items-center justify-center gap-1.5 sm:gap-2 border border-white/20 text-white font-heading uppercase tracking-wide text-[11px] sm:text-sm py-3 px-1 hover:border-[#ff0033] hover:text-[#ff0033] transition-colors"
        >
          <Target size={15} className="shrink-0" />
          <span className="truncate">{t("Einzeltraining", "Private")}</span>
        </Link>
        <Link
          to="/onlinecoaching"
          data-testid="sticky-cta-online"
          className="flex items-center justify-center gap-1.5 sm:gap-2 bg-[#ff0033] text-white font-heading uppercase tracking-wide text-[9px] sm:text-sm py-3 px-1 hover:bg-[#cc0029] transition-colors"
        >
          <Globe size={15} className="shrink-0 hidden sm:block" />
          <span>golfcoaching.online</span>
        </Link>
      </div>
    </div>
  );
};

export default StickyCTA;
